import {GridFilterInputBoolean, GridFilterInputValue} from "@mui/x-data-grid";

export const textFilterOperators = [
    {
        label: "Contains",
        value: "CONTAINS",
        InputComponent: GridFilterInputValue,
        InputComponentProps: {
            type: "text",
        },
    },
    {
        label: "Does not contain",
        value: "DOES_NOT_CONTAIN",
        InputComponent: GridFilterInputValue,
        InputComponentProps: {
            type: "text",
        },
    },
    {
        label: "Equal to",
        value: "EQUAL_TO",
        InputComponent: GridFilterInputValue,
        InputComponentProps: {
            type: "text",
        },
    },
    {
        label: "Not equal to",
        value: "NOT_EQUAL_TO",
        InputComponent: GridFilterInputValue,
        InputComponentProps: {
            type: "text",
        },
    },
];

export const numberFilterOperators = [
    {
        label: "=",
        value: "EQUAL_TO",
        InputComponent: GridFilterInputValue,
        InputComponentProps: {
            type: "number",
        },
    },
    {
        label: "!=",
        value: "NOT_EQUAL_TO",
        InputComponent: GridFilterInputValue,
        InputComponentProps: {
            type: "number",
        },
    },
    {
        label: ">",
        value: "GREATER_THAN",
        InputComponent: GridFilterInputValue,
        InputComponentProps: {
            type: "number",
        },
    },
    {
        label: ">=",
        value: "GREATER_THAN_OR_EQUAL_TO",
        InputComponent: GridFilterInputValue,
        InputComponentProps: {
            type: "number",
        },
    },
    {
        label: "<",
        value: "LESS_THAN",
        InputComponent: GridFilterInputValue,
        InputComponentProps: {
            type: "number",
        },
    },
    {
        label: "<=",
        value: "LESS_THAN_OR_EQUAL_TO",
        InputComponent: GridFilterInputValue,
        InputComponentProps: {
            type: "number",
        },
    },
];

export const booleanFilterOperators = [
    {
        label: "is",
        value: "IS",
        InputComponent: GridFilterInputBoolean,
        InputComponentProps: {
            type: "boolean",
        },
    },
];
export const disableSortingAndMenu = (header) => {
    header.map((column) => {
        column["disableColumnMenu"] = true;
        column["sortable"] = false;
        return column;
    });
    return header;
};
